import React, {useEffect, useState} from 'react';
import {Link, Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import {getJobPostingDetail} from "../../api/jobApi";


const JobDetail: React.FC = () => {
    const {jobPostingCode} = useParams<{ jobPostingCode: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const [isApplier, setIsApplier] = useState(false);

    // jobPostingCode가 있으면 sessionStorage에 저장
    useEffect(() => {
        if (jobPostingCode) {
            sessionStorage.setItem('currentJobPostingCode', jobPostingCode);
        }
    }, [jobPostingCode]);

    // sessionStorage에서 가져오기 (fallback)
    const currentJobPostingCode = jobPostingCode || sessionStorage.getItem('currentJobPostingCode') || '';

    const isDetailActive = location.pathname.includes('/detail');
    const isCoordiActive = location.pathname.includes('/coordi');

    // 공고 작성자 여부 확인
    useEffect(() => {
        if (currentJobPostingCode) {
            getJobPostingDetail(currentJobPostingCode).then((res) => {
                const data = res.data?.data || res.data;
                setIsApplier(data?.isApplier || false);
            }).catch(() => {});
        }
    }, [currentJobPostingCode]);

    useEffect(() => {
        // 첫 진입 시 /detail로 리다이렉트
        if (currentJobPostingCode && location.pathname === `/announcement/${currentJobPostingCode}`) {
            navigate(`/announcement/${currentJobPostingCode}/detail`, {replace: true});
        }
        // 작성자가 아닌데 코디 탭에 접근하면 detail로 리다이렉트
        if (!isApplier && isCoordiActive) {
            navigate(`/announcement/${currentJobPostingCode}/detail`, {replace: true});
        }
    }, [currentJobPostingCode, location.pathname, navigate, isApplier, isCoordiActive]);

    return (
        <main className={`container type_gray${isApplier ? ' has-tab' : ''}`}>
            {isApplier && (
                <section className="tabFixed">
                    <ul className="tab_wrap">
                        <li>
                            <Link
                                to={`/announcement/${currentJobPostingCode}/detail`}
                                className={isDetailActive ? "active" : ""}
                            >
                                공고 상세
                            </Link>
                        </li>
                        <li>
                            <Link
                                to={`/announcement/${currentJobPostingCode}/coordi`}
                                className={isCoordiActive ? "active" : ""}
                            >
                                지원 코디
                            </Link>
                        </li>
                    </ul>
                </section>
            )}

            <Outlet/>
        </main>
    );
};
export default JobDetail;